document.addEventListener('turbolinks:load', () => {

    const stationMediaEntryTableBody = document.getElementById('stationMediaEntryTableBody')
    //is null without media in the station
    const stationMediaTable = document.getElementById('stationMediaTable')


    const previewImageType = document.getElementById('previewImageType')

    if (stationMediaEntryTableBody !== null) {

        let current = null
        let tableRows = stationMediaEntryTableBody.getElementsByTagName("tr");

        for (let tr of tableRows) {
            tr.draggable = true;

            // START
            tr.addEventListener("dragstart", function (ev) {
                current = this;
                //Remove the alternate-children class, because this bg-color gets used otherwise and the added color classes don't work
                stationMediaTable.classList.remove('alternate-children')
                // style other elements
                for (let it of tableRows) {
                    if (it !== current) {
                        it.classList.add("bg-amber-200")
                    }
                }
            });

            // ENTER
            tr.addEventListener("dragenter", function (ev) {
                for (let it of tableRows) {
                    if (current !== null) {
                        if (it !== tr && it !== current) {
                            // other stations
                            it.classList.add("bg-amber-200")
                            it.classList.remove("bg-red-200")
                        } else if (it === tr && it !== current) {
                            // reached station
                            it.classList.add("bg-red-200")
                            it.classList.remove("bg-amber-200")
                        }
                    }
                }
            });

            //LEAVE
            tr.addEventListener("dragleave", function () {
            });

            // END
            tr.addEventListener("dragend", function (ev) {
                // reset everything
                current = null
                stationMediaTable.classList.add('alternate-children')
                for (let it of tableRows) {
                    it.classList.remove("bg-amber-200")
                    it.classList.remove("bg-red-200")
                }
            });

            // OVER
            tr.addEventListener("dragover", function (evt) {
                evt.preventDefault();
            });

            // DROP
            tr.addEventListener("drop", function (evt) {
                evt.preventDefault();
                if (this !== current) {
                    const previousFirstMediaId = tableRows[0].dataset.mediaId
                    let currentPos = 0;
                    let droppedPos = 0;
                    for (let it=0; it<tableRows.length; it++) {
                        if (current === tableRows[it]) {
                            currentPos = it;
                        }
                        if (this === tableRows[it]) {
                            droppedPos = it;
                        }
                    }

                    if (currentPos < droppedPos) {
                        this.parentNode.insertBefore(current, this.nextSibling);
                    } else {
                        this.parentNode.insertBefore(current, this);
                    }

                    // tableRows is a live collection, so tableRows[0] is the new first row
                    const newFirstMediaId = tableRows[0].dataset.mediaId
                    if (newFirstMediaId !== previousFirstMediaId) {
                        updateFirstMediaEntryPreview(newFirstMediaId)
                    }
                }

            });

        }
    }

    // Updates the media id of the 'first_station_media_entry' preview option.
    // If this option is currently selected, a change event is dispatched so that station.js requests the new preview images.
    function updateFirstMediaEntryPreview(mediaId) {
        if (previewImageType === null) {
            return
        }
        const firstMediaEntryOption = previewImageType.querySelector('option[value="first_station_media_entry"]')
        if (firstMediaEntryOption === null) {
            return
        }
        firstMediaEntryOption.dataset.mediaId = mediaId
        if (previewImageType.value === "first_station_media_entry") {
            previewImageType.dispatchEvent(new Event('change'))
        }
    }

});